<template>
    <div class="no_data column_center">
        <img src="../assets/no_data.png" alt="">
        <div class="d_txt">暂无相关数据</div>
    </div>
</template>

<script>
    export default {
        name: "no_data"
    }
</script>

<style scoped lang="scss">
    .no_data {
        width: 100%;
        padding: 100px;
        box-sizing: border-box;
        img {
            width: 300px;
            height: 300px;
        }
        .d_txt {
            font-size: 14px;
            color: #8c8c8c;
        }
    }
</style>
